import type { AdminSectionGroup, AdminSectionId } from './types'
import { cx } from '@ui/classes'

/** Пункт навигации админки. */
export interface AdminNavItem {
  id: AdminSectionId
  label: string
  group: AdminSectionGroup
}

/** Подписи групп меню. */
const GROUP_LABELS: Record<AdminSectionGroup, string> = {
  work: 'Работа',
  shop: 'Магазин',
  settings: 'Настройки'
}

const GROUP_ORDER: AdminSectionGroup[] = ['work', 'shop', 'settings']

/**
 * Навигация админки: на десктопе — вертикальная колонка с группами,
 * в компактном лэйауте — выпадающий список с <optgroup>.
 */
export function AdminNav({
  items,
  active,
  onSelect,
  compact
}: {
  items: AdminNavItem[]
  active: AdminSectionId
  onSelect: (id: AdminSectionId) => void
  compact: boolean
}) {
  if (compact) {
    return (
      <label className="mb-3 flex flex-col gap-1 text-small">
        Раздел
        <select
          className="rounded-card border border-lineStrong bg-white px-2.5 py-2 text-sm"
          value={active}
          onChange={(e) => onSelect(e.target.value as AdminSectionId)}
        >
          {GROUP_ORDER.map((group) => {
            const groupItems = items.filter((i) => i.group === group)
            if (groupItems.length === 0) return null
            return (
              <optgroup key={group} label={GROUP_LABELS[group]}>
                {groupItems.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.label}
                  </option>
                ))}
              </optgroup>
            )
          })}
        </select>
      </label>
    )
  }

  return (
    <nav className="flex w-[200px] shrink-0 flex-col gap-0.5" aria-label="Разделы кабинета">
      {GROUP_ORDER.map((group) => {
        const groupItems = items.filter((i) => i.group === group)
        if (groupItems.length === 0) return null
        return (
          <div key={group} className="mb-2">
            <div className="px-3 pb-1 pt-2 text-micro font-semibold uppercase tracking-wide text-muted">
              {GROUP_LABELS[group]}
            </div>
            {groupItems.map((item) => (
              <button
                key={item.id}
                type="button"
                onClick={() => onSelect(item.id)}
                aria-current={active === item.id ? 'page' : undefined}
                className={cx(
                  'w-full cursor-pointer rounded-card px-3 py-2 text-left text-sm',
                  active === item.id ? 'bg-accent font-semibold text-white' : 'text-ink hover:bg-soft'
                )}
              >
                {item.label}
              </button>
            ))}
          </div>
        )
      })}
    </nav>
  )
}
